import SharesWidget from './SharesWidget';

export default SharesWidget;
